export type ScrollGalleryImage = {
  src: string
  alt: string
  title: string
  description: string
}

/**
 * Images sorted by dominant color for a smooth visual gradient:
 * dark/red → fire/orange → pink → purple → blue → cyan → green → yellow → white/neutral → dark
 */
export const SCROLL_GALLERY_IMAGES: ScrollGalleryImage[] = [
  /* ── DARK RED / BLACK ─────────────────────────────────────── */
  {
    src: '/gallery/thumbnails/maxresdefault-8.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Campaign Ready',
    title: 'Campaign Ready',
    description: 'Dostarczamy wyniki, nie obietnice.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-1.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Bold Concept',
    title: 'Bold Concept',
    description: 'Wyraziste pomysły, które przyciągają.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-3.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Dynamic Energy',
    title: 'Dynamic Energy',
    description: 'Energia, która zatrzymuje scrollowanie.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-29.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Power Frame',
    title: 'Power Frame',
    description: 'Kompozycja, która dominuje feed.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-10.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Direct Response',
    title: 'Direct Response',
    description: 'Click-through rate na poziomie PRO.',
  },

  /* ── RED / FIRE / ORANGE ──────────────────────────────────── */
  {
    src: '/gallery/thumbnails/0823.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Cinematic Feel',
    title: 'Cinematic Feel',
    description: 'Filmowy charakter w miniaturze.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-18.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Hook Visual',
    title: 'Hook Visual',
    description: 'Hak wizualny, który nie puszcza.',
  },
  {
    src: '/gallery/thumbnails/0822.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Raw Emotion',
    title: 'Raw Emotion',
    description: 'Prawdziwe emocje na pierwszym planie.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-14.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Dramatic Flair',
    title: 'Dramatic Flair',
    description: 'Dramatyzm, który angażuje.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-14.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Production Mastery',
    title: 'Production Mastery',
    description: 'Jakość, która redefiniuje formaty.',
  },
  {
    src: '/gallery/thumbnails/1768.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Collector Edition',
    title: 'Collector Edition',
    description: 'Detale, które robią różnicę.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-7.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Emotion First',
    title: 'Emotion First',
    description: 'Emocje, które konwertują na kliknięcia.',
  },

  /* ── WARM ORANGE / AMBER ──────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-9.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Visual Punch',
    title: 'Visual Punch',
    description: 'Mocny przekaz w jednym obrazie.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-19.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Text Impact',
    title: 'Text Impact',
    description: 'Typografia, która wzmacnia przekaz.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-32.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Bold & Bright',
    title: 'Bold & Bright',
    description: 'Odwaga wizualna, która się opłaca.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-12.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Contrast King',
    title: 'Contrast King',
    description: 'Kontrasty, które wyróżniają.',
  },

  /* ── HOT PINK / MAGENTA ───────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-28.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Neon Glow',
    title: 'Neon Glow',
    description: 'Efekty świetlne na najwyższym poziomie.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-20.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Scale Fast',
    title: 'Scale Fast',
    description: 'Optymalizacja pod algorytm YouTube.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-21.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: High Performance',
    title: 'High Performance',
    description: 'Miniatury, które przyciągają wzrok.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-22.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: YouTube Growth',
    title: 'YouTube Growth',
    description: 'Systematyczne podejście do CTR.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-23.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Moment Capture',
    title: 'Moment Capture',
    description: 'Złapany moment, który opowiada historię.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-19.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Eye Catching',
    title: 'Eye Catching',
    description: 'Zwiększamy zasięgi Twoich treści.',
  },

  /* ── PINK → PURPLE TRANSITION ─────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-30.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Viral Ready',
    title: 'Viral Ready',
    description: 'Zaprojektowane pod viralowy potencjał.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-5.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Sharp Composition',
    title: 'Sharp Composition',
    description: 'Każdy element na swoim miejscu.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-6.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Click Magnet',
    title: 'Click Magnet',
    description: 'CTR rośnie z każdą miniaturą.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-12.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Brand Impact',
    title: 'Brand Impact',
    description: 'Twój wizerunek w profesjonalnych rękach.',
  },

  /* ── DEEP BLUE / ICY BLUE ─────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-31.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Mood Setter',
    title: 'Mood Setter',
    description: 'Nastrój, który definiuje markę.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-8.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Scene Setting',
    title: 'Scene Setting',
    description: 'Sceny, które intrygują od razu.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-21.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Pattern Break',
    title: 'Pattern Break',
    description: 'Łamiemy schematy, budujemy zasięgi.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-2.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Visual Storytelling',
    title: 'Visual Storytelling',
    description: 'Historia opowiedziana jednym kadrem.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-13.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Consistent Results',
    title: 'Consistent Results',
    description: 'Zaufanie największych twórców.',
  },

  /* ── CYAN / TEAL ──────────────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-22.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Vivid Colors',
    title: 'Vivid Colors',
    description: 'Paleta barw dopasowana do marki.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-18.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Digital Strategy',
    title: 'Digital Strategy',
    description: 'Kompleksowa produkcja wizualna.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-20.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Light & Shadow',
    title: 'Light & Shadow',
    description: 'Światłocień jako narzędzie narracji.',
  },

  /* ── GREEN ────────────────────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-11.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Clean Layout',
    title: 'Clean Layout',
    description: 'Przejrzystość, która sprzedaje.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-15.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Trend Setter',
    title: 'Trend Setter',
    description: 'Wyznaczamy trendy wizualne.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-17.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Action Shot',
    title: 'Action Shot',
    description: 'Dynamika zamrożona w kadrze.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-26.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Fresh Take',
    title: 'Fresh Take',
    description: 'Świeże spojrzenie na każdy temat.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-10.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Scroll Stopper',
    title: 'Scroll Stopper',
    description: 'Zatrzymujemy palce na ekranie.',
  },
  {
    src: '/gallery/thumbnails/1598.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Adventure Mode',
    title: 'Adventure Mode',
    description: 'Przygoda zaczyna się od kliknięcia.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-17.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Creator Flow',
    title: 'Creator Flow',
    description: 'Uwalniamy Twój czas na tworzenie.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-13.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Curiosity Gap',
    title: 'Curiosity Gap',
    description: 'Miniatura, która budzi ciekawość.',
  },

  /* ── YELLOW / GOLD ────────────────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-33.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Story Tease',
    title: 'Story Tease',
    description: 'Zapowiedź historii w jednym kadrze.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-34.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Peak Creative',
    title: 'Peak Creative',
    description: 'Kreatywność bez kompromisów.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-16.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Face Forward',
    title: 'Face Forward',
    description: 'Twarze, które budują rozpoznawalność.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-27.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Depth Layer',
    title: 'Depth Layer',
    description: 'Głębia, która wciąga widza.',
  },
  {
    src: '/gallery/thumbnails/miniaturki.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Ultimate Results',
    title: 'Ultimate Results',
    description: '12 000+ wyprodukowanych grafik.',
  },

  /* ── WHITE / BRIGHT / NEUTRAL ─────────────────────────────── */
  {
    src: '/gallery/thumbnails/kocham-kreta-24.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Edge Design',
    title: 'Edge Design',
    description: 'Design na krawędzi konwencji.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-25.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Reaction Shot',
    title: 'Reaction Shot',
    description: 'Reakcje, które rezonują z widzami.',
  },
  {
    src: '/gallery/thumbnails/kocham-kreta-4.jpg',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Color Play',
    title: 'Color Play',
    description: 'Kolory, które budują emocje.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-11.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Modern Style',
    title: 'Modern Style',
    description: 'Wizualny język generacji YouTube.',
  },

  /* ── MIXED / DARK CLOSING ─────────────────────────────────── */
  {
    src: '/gallery/thumbnails/maxresdefault-5.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Future Format',
    title: 'Future Format',
    description: 'Kreujemy trendy, zamiast za nimi podążać.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-6.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Content Control',
    title: 'Content Control',
    description: 'Pełny system operacyjny dla kanału.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-7.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Premium Touch',
    title: 'Premium Touch',
    description: 'Każdy piksel ma znaczenie.',
  },
  {
    src: '/gallery/thumbnails/maxresdefault-9.webp',
    alt: 'Miniatura YouTube zaprojektowana przez FLOU: Visual Identity',
    title: 'Visual Identity',
    description: 'Spójność między platformami.',
  },
]
